import { proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { ArticleEnvironment } from '../environment';
import { RecommendedResponse } from '../entities';
import { recommendedArticlesRoutes } from './recommendedRoutes';

export class RecommendedRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).recommendedArticlesUrl, session, undefined, proxyClientOptions());
  }

  getRecommendedArticles = (nid: number | string, userId = '', limit = 4): SafePromise<RecommendedResponse> => {
    const path = this.routePath(recommendedArticlesRoutes.recommended);
    const url = this.URL(path, {
      limit,
      source_article_id: nid.toString(),
      user_id: userId,
    });
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };
}
